import 'angular:locale/data:is-IS';
import 'zone.js';
import '@angular/localize/init';(globalThis.$localize ??= {}).locale = "is-IS";
